import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { DownloadService } from 'app/core/services/download.service';
import { LimitOffsetPaging } from 'app/core/models/paged-results/limit-offset-paging.model';
import { ImportNavComponent } from '../../../shared/components/import-nav/import-nav.component';
import { DecimalPipe, TitleCasePipe, DatePipe } from '@angular/common';
import { PaginationHeaderComponent } from '../../../shared/components/pagination-header/pagination-header.component';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { NgbDropdown, NgbDropdownToggle, NgbDropdownMenu } from '@ng-bootstrap/ng-bootstrap';
import { PaginationComponent } from '../../../shared/components/pagination/pagination.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { BlankValueDashPipe } from '../../../shared/pipes/blank-value-dash.pipe';
import { PharmacyStoreIdentifierMappingImport } from 'app/core/models/pharmacy-store-identifier-mapping-import.model';
import { PharmacyStoreIdentifierMappingImportsService } from 'app/core/services/pharmacy-store-identifier-mapping-imports.service';

@Component({
  selector: 'app-capture-admin-import-pharmacy-store-identifier-mappings-history',
  templateUrl: './capture-admin-import-pharmacy-store-identifier-mappings-history.component.html',
  imports: [
    ImportNavComponent,
    PaginationHeaderComponent,
    FaIconComponent,
    NgbDropdown,
    NgbDropdownToggle,
    NgbDropdownMenu,
    PaginationComponent,
    MatProgressSpinner,
    DecimalPipe,
    TitleCasePipe,
    DatePipe,
    BlankValueDashPipe
  ]
})
export class CaptureAdminImportPharmacyStoreIdentifierMappingsHistoryComponent implements OnInit, OnDestroy {
  private pharmacyStoreIdentifierMappingImportsService = inject(PharmacyStoreIdentifierMappingImportsService);
  private downloadService = inject(DownloadService);

  loading = false;
  pharmacyStoreIdentifierMappingImports: PharmacyStoreIdentifierMappingImport[] = [];
  nextCheckTimeout = null;
  paging: LimitOffsetPaging;

  ngOnInit() {
    this.paging = LimitOffsetPaging.empty;
    this.paging.currentPage = 1;
    this.loadImports(this.paging.currentPage);
  }

  ngOnDestroy() {
    clearTimeout(this.nextCheckTimeout);
  }

  onPageSizeChange(size: number) {
    this.paging.pageSize = size;
    this.loadImports(this.paging.currentPage);
  }

  onPageChange(page: number) {
    this.loadImports(page);
  }

  onCancelClick(
    $event: MouseEvent,
    pharmacyStoreIdentifierMappingImport: PharmacyStoreIdentifierMappingImport
  ) {
    $event.preventDefault();
    this.pharmacyStoreIdentifierMappingImportsService.
      cancel(pharmacyStoreIdentifierMappingImport.id).subscribe(mappingImport => {
        const index = this.pharmacyStoreIdentifierMappingImports.findIndex(imp => imp.id === mappingImport.id);

        if (index > -1) {
          this.pharmacyStoreIdentifierMappingImports[index] = mappingImport;
          this.pharmacyStoreIdentifierMappingImports = [...this.pharmacyStoreIdentifierMappingImports];
        }
      });
  }

  onDownloadOriginalClick(
    $event: MouseEvent,
    pharmacyStoreIdentifierMappingImport: PharmacyStoreIdentifierMappingImport
  ) {
    $event.preventDefault();
    this.pharmacyStoreIdentifierMappingImportsService.
      get(pharmacyStoreIdentifierMappingImport.id).subscribe(mappingImport => {
        const downloadUrl = mappingImport.fileExpirableDownloadPath;
        this.downloadService.getDownloadUrl(downloadUrl).subscribe(expirableDownload => {
          this.downloadService.download(expirableDownload.url);
        });
      });
  }

  onDownloadSkippedClick(
    $event: MouseEvent,
    pharmacyStoreIdentifierMappingImport: PharmacyStoreIdentifierMappingImport
  ) {
    $event.preventDefault();
    this.pharmacyStoreIdentifierMappingImportsService.
      get(pharmacyStoreIdentifierMappingImport.id).subscribe(mappingImport => {
        const downloadUrl = mappingImport.skippedFileExpirableDownloadPath;
        this.downloadService.getDownloadUrl(downloadUrl).subscribe(expirableDownload => {
          this.downloadService.download(expirableDownload.url);
        });
      });
  }

  private loadImports(page: number, loading = true) {
    this.loading = loading;
    const paging = { page, pageSize: this.paging.pageSize };
    this.pharmacyStoreIdentifierMappingImportsService.getList(paging).subscribe(result => {
      this.pharmacyStoreIdentifierMappingImports = result.pharmacyStoreIdentifierMappingImports;
      this.paging = result.meta.paging;
      this.loading = false;

      const anyActive: boolean = this.pharmacyStoreIdentifierMappingImports.some(mappingImport => mappingImport.active);

      if (anyActive) {
        this.nextCheckTimeout = setTimeout(() => this.loadImports(this.paging.currentPage, false), 500);
      }
    });
  }
}
